import intermoji from '@intercom/intermoji';
export const replaceUnicodeWithColonified = function replaceUnicodeWithColonified(string) {
  return intermoji.splitOnUnicodeEmojis(string).reduce(function (prev, item) {
    return prev += intermoji.isSupportedUnicode(item) ? wrapInColons(intermoji.identifierFromUnicode(item)) : item;
  }, '');
};
let _hasNativeEmojiSupport;
export const hasNativeEmojiSupport = function () {
  if (_hasNativeEmojiSupport === undefined) {
    _hasNativeEmojiSupport = intermoji.hasNativeSupport(document);
  }
  return _hasNativeEmojiSupport;
};
export const disableNativeEmojiSupport = function disableNativeEmojiSupport() {
  _hasNativeEmojiSupport = false;
};
export const enableNativeEmojiSupport = function enableNativeEmojiSupport() {
  _hasNativeEmojiSupport = true;
};
function wrapInColons(string) {
  return `:${string}:`;
}